<template>
  <div class="chatMain">
    <el-drawer
        ref="sideDrawer"
        :visible.sync="showDrawerSide"
        direction="ltr"
        custom-class="sideDrawer"
        :size="'80%'"
        :close-on-press-escape="false"
        :wrapperClosable="false"
        :before-close="handleClose">
      <chatSidebar
          :userinfo="userinfo"
          :screenWidth="screenWidth"
          :class="[showDrawerSide?'flex':'']"
          :sessions="sessions"
          :currentSessionIndex="currentSessionIndex"
          :isDark="isDark"
          :models="models"
          :selectedModel="selectedModel"
          @create-new-session="createNewSession"
          @select-session="selectSession"
          @delete-session="deleteSession"
          @change-model="changeModel"
          @top-or-cancel="topOrCancel"
          @closeSideBar="closeSideBar"
      />
    </el-drawer>
    <chatSidebar
        :userinfo="userinfo"
        :screenWidth="screenWidth"
        :showDrawerSide="showDrawerSide"
        :sessions="sessions"
        :currentSessionIndex="currentSessionIndex"
        :isDark="isDark"
        :models="models"
        :selectedModel="selectedModel"
        @create-new-session="createNewSession"
        @select-session="selectSession"
        @delete-session="deleteSession"
        @change-model="changeModel"
        @top-or-cancel="topOrCancel"
        @initBuyNowPC="initBuyNowPC"
    />
    <chatPanel
        ref="chatPanelRef"
        :models="models"
        :isDark="isDark"
        :screenWidth="screenWidth"
        :messages="messages"
        @get-conversations="getConversations"
        @toggle-theme="toggleTheme"
        @clickFolder="clickFolder"
        @initBuyNowPhone="initBuyNowPhone"
    />
    <buyNowPhone ref="buyNowPhoneRef"/>
    <buyNowPC ref="buyNowPC"/>
  </div>
</template>

<script>
import chatSidebar from "./chatSidebar";
import chatPanel from "./chatPanel";
import buyNowPhone from "./phone/buyNow";
import buyNowPC from "./pc/buyNow";
import {
  formatObj,
  getUserInfo,
  isEmpty,
  filterObj
} from '@/util/util'
import {
  getAiModelList,
  getMessageAIList,
  getConversationsList,
  deleteConversation,
  updateTopFlag
} from "@/request/requests";

export default {
  name: "shareAI",
  components: {
    chatSidebar,
    chatPanel,
    buyNowPhone,
    buyNowPC
  },
  data() {
    return {
      showDrawerSide: false,
      screenWidth: null,
      userinfo: {}
    }
  },
  computed: {
    sessions: {
      get() {
        return this.$store.state.chat.sessions;
      },
      set(val) {
        this.$store.commit('chat/SET_SESSION', val);
      }
    },
    currentSessionIndex() {
      return this.$store.state.chat.currentSessionIndex;
    },
    messages: {
      get() {
        return this.$store.state.chat.messages;
      },
      set(val) {
        this.$store.commit('chat/SET_MESSAGES', val);
      }
    },
    models: {
      get() {
        return this.$store.state.chat.models;
      },
      set(val) {
        this.$store.commit('chat/SET_MODELS', val)
      }
    },
    selectedModel: {
      get() {
        return this.$store.state.chat.selectedModel;
      },
      set(val) {
        this.$store.commit('chat/SET_SELECTED_MODEL', val)
      }
    },
    isDark() {
      return this.$store.state.chat.isDark;
    },
    conversationId: {
      get() {
        return this.$store.state.chat.conversationId;
      },
      set(val) {
        this.$store.commit('chat/SELECT_SESSION', val)
      }
    },
    img:{
      get(){
        return this.$store.state.chat.img;
      },
      set(val){
        this.$store.commit('chat/SET_IMG', val)
      }
    },
    parentMessageId:{
      get(){
        return this.$store.state.chat.parentMessageId;
      },
      set(val){
        this.$store.commit('chat/SET_PARENT_MESSAGE_ID',val)
      }
    }
  },
  watch: {
    screenWidth: {
      handler(newVal) {
        if (newVal > 768) {
          this.showDrawerSide = false;
          this.closeSideBar();
          this.$nextTick(() => {
            if (this.$refs['buyNowPhoneRef'].dialogFormVisible) {
              this.$refs['buyNowPhoneRef'].dialogFormVisible = false;
              this.$refs['buyNowPC'].init();
            }
          })
        } else {
          this.$nextTick(() => {
            if (this.$refs['buyNowPC'].dialogFormVisible) {
              this.$refs['buyNowPC'].dialogFormVisible = false;
              this.$refs['buyNowPhoneRef'].init();
            }
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    async getConversations(flag) {
      let params = {
        user_id: this.userinfo.id
      }
      let res = await getConversationsList(this.$qs.stringify(params));
      if (res.status == '200') {
        let sessionList = formatObj(res.data) || [];
        if (!isEmpty(sessionList)) {
          sessionList.forEach(sItem => {
            //处理显示日期
            this.$set(sItem, 'updatedAt', this.$moment(sItem.updatedAt).format('yyyy-MM-DD HH:mm:ss'));
          })
        }
        this.sessions = sessionList;
        if(flag){
          this.selectSession(this.conversationId)
        }
      }
    },
    async getModels() {
      let res = await getAiModelList();
      if (res.status == "200") {
        this.models = res.data?.list;
        if (!isEmpty(this.models)) {
          //模型需要设置默认值
          this.selectedModel = this.models[0]?.modelCode;
          //深度思考赋值
          //this.hasDeepThinking = this.models[0]?.hasDeepThinking;
        }
      }
    },
    initBuyNowPC() {
      this.$refs['buyNowPC'].init();
    },
    initBuyNowPhone() {
      this.$refs['buyNowPhoneRef'].init();
    },
    clickFolder() {
      this.showDrawerSide = !this.showDrawerSide;
    },
    closeSideBar() {
      this.$nextTick(() => {
        this.$refs['sideDrawer'].closeDrawer();
      })
    },
    handleClose(done) {
      done();
    },
    async topOrCancel(data, sIndex) {
      if (!isEmpty(data.conversationId)) {
        let params = {
          conversationId: data.conversationId,
          topFlag: data.topFlag == '0' ? '1' : '0'
        }
        let res = await updateTopFlag(params);
        if (res.status == '200') {
          //刷新左侧会话列表
          this.getConversations();
        }
      }
    },
    createNewSession() {
      this.$refs['chatPanelRef'].reset();
      //this.messages = [];
      this.conversationId = '';
    },
    async selectSession(conversationId) {
      this.conversationId = conversationId;
      let params = {
        conversationId: conversationId
      }
      let res = await getMessageAIList(this.$qs.stringify(params));
      if (res.status == '200') {
        let list = res.data || [];
        if(!isEmpty(list)){
          list.forEach(item=>{
            if(item.role==='assistant'&&item.reasoningContent){
              //深度思考展开
              this.$set(item,'showConsider',true);
              this.$set(item,'showMarkdown',true);
            }
          })
        }
        this.parentMessageId = filterObj(list,'parentMessageId',this.conversationId).parentMessageId;
        this.$refs['chatPanelRef'].setMessageList(list);
        //this.messages = res.data || [];
        // let imgUrlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/g;
        // if(!isEmpty(this.messages)){
        //   let match;
        //   this.messages.forEach(mItem=>{
        //     while ((match = imgUrlRegex.exec(mItem.content)) !== null) {
        //       console.log(match);
        //
        //     }
        //   })
        // }
      }
    },
    async deleteSession(conversationId) {
      //已经发送过对话
      if (!isEmpty(conversationId)) {
        let params = {conversationId}
        let res = await deleteConversation(this.$qs.stringify(params));
        if (res.status == '200') {
          if (conversationId === this.conversationId) {
            //this.messages = [];
            this.$refs['chatPanelRef'].reset();
            this.img = '';
          }
          this.getConversations();
        }
      }
    },
    sendMessage(message) {
      this.$store.dispatch('chat/sendMessage', message);
    },
    changeModel(model) {
      this.$store.dispatch('chat/changeModel', model);
    },
    toggleTheme() {
      this.$store.dispatch('chat/toggleTheme');
    },
    calcWidth() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.$forceUpdate();
    }
  },
  mounted() {
    let userInfo = getUserInfo();
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
    }

    //获取侧边栏会话列表
    this.getConversations();
    //获取模型下拉列表
    this.getModels();
    // 初始化选中窗口
    this.$store.state.chat.conversationId=null;
    const crispClientElements = document.getElementsByClassName('crisp-client');
    for (let i = 0; i < crispClientElements.length; i++) {
      crispClientElements[i].style.display = 'none';
    }
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/shareAI.scss";
</style>